import { render, staticRenderFns } from "./OnSale.vue?vue&type=template&id=1d408228"
import script from "./OnSale.vue?vue&type=script&lang=js"
export * from "./OnSale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductCarousel: require('/opt/build/repo/components/product/Carousel.vue').default,SectionBase: require('/opt/build/repo/components/section/Base.vue').default})
